/*
 * サブシステム名：マスタ管理
 * 機能名：定型コース一覧
 * package版
 */

import date from '@/ddv2.library/date'
import flowMixin from '@/mixins/flowMixins'
import filter from '@/rahmen/utils/filters'
import { mapGetters } from 'vuex'

import header from '@/ddv2.library/header'
import modals from '@/ddv2.library/modals'

const DdSearchList = () => import('@/components/DdSearchList')
const DdCodeTextBox = () => import('@/components/DdCodeTextBox')
const DdDropDown = () => import('@/components/DdDropDown')
const DdTextBox = () => import('@/components/DdTextBox')

export default {
  name: 'MstTeikeiCorceListForPackage',
  mixins: [flowMixin],
  data: () => ({
    // 一覧制御用
    selected: [],
    itemsPerPage: 100,
    page: 1,
    isConditionHide: false,
    isCsvDownloader: false,
    isPdfDownloader: false,
    conditions: {
      teikeiCourseNo: '',
      teikeiCourseNm: '',
      tokuisakiCd: '',
      chumonNo: '',
      ohfukuSbt: '',
      seikyuShashuSbt: '',
      tantoEigyoshoCd: '',
      hatsuchiCd: '',
      chakuchiCd: ''
    },

    mstEigyoshoHeader: header.mstEigyoshoHeaders,
    mstTorihikisakiHeader: header.mstTorihikisakiHeaders,
    mstHacchakuchiHeaders: header.mstHacchakuchiHeaders,
    modeKengen: 0
  }),
  components: {
    DdSearchList,
    DdCodeTextBox,
    DdDropDown,
    DdTextBox
  },
  computed: {
    filteredRows () {
      console.log('filter', this.rows)
      return this.rows.map((elem) => {
        if (elem.tokuisakiId) { elem.tokuisakiDisp = elem.tokuisakiCd + ' : ' + elem.tokuisakiNm }
        elem.hinmeiDisp = elem.mstHinmeiId ? elem.hinmeiCd + ' : ' + elem.hinmeiNm : elem.hinmeiBiko
        elem.hatsuchiDisp = elem.hatsuchiId ? elem.hatsuchiCd + ' : ' + elem.hatsuchiNm : elem.hatsuchiBiko
        elem.chakuchiDisp = elem.chakuchiId ? elem.chakuchiCd + ' : ' + elem.chakuchiNm : elem.chakuchiBiko
        elem.keiyuchiId1Disp = elem.keiyuchiId1 ? elem.keiyuchiId1Cd + ' : ' + elem.keiyuchiId1Nm : elem.keiyuchiId1Biko
        if (elem.tantoEigyoshoId) { elem.tantoEigyoshoDisp = elem.tantoEigyoshoCd + ' : ' + elem.tantoEigyoshoNm }
        elem.hatsuchiHmsDisp = elem.hatsuchiHms ? (elem.hatsuchiHms).slice(0, 5) : elem.hatsuchiHmsBiko
        elem.chakuchiHmsDisp = elem.chakuchiHms ? (elem.chakuchiHms).slice(0, 5) : elem.chakuchiHmsBiko
        if (elem.juchuSuryo) { elem.juchuSuryo = filter.numericFormatter(elem.juchuSuryo) }
        if (elem.juchuJuryo) { elem.juchuJuryo = filter.numericFormatter(elem.juchuJuryo) }
        if (elem.tanka) { elem.tanka = filter.numericFormatter(elem.tanka) }
        if (elem.kihonUnchin) { elem.kihonUnchin = filter.numericFormatter(elem.kihonUnchin) }
        if (elem.hiwayPrice) { elem.hiwayPrice = filter.numericFormatter(elem.hiwayPrice) }
        if (elem.unchinHokaKingaku) { elem.unchinHokaKingaku = filter.numericFormatter(elem.unchinHokaKingaku) }
        if (elem.unchinHokaHikazei) { elem.unchinHokaHikazei = filter.numericFormatter(elem.unchinHokaHikazei) }
        if (elem.jikanWarimashiKingaku) { elem.jikanWarimashiKingaku = filter.numericFormatter(elem.jikanWarimashiKingaku) }
        if (elem.kyoriWarimashiKingaku) { elem.kyoriWarimashiKingaku = filter.numericFormatter(elem.kyoriWarimashiKingaku) }
        if (elem.warimashiSonotaKingaku) { elem.warimashiSonotaKingaku = filter.numericFormatter(elem.warimashiSonotaKingaku) }
        if (elem.seikyuGokei) { elem.seikyuGokei = filter.numericFormatter(elem.seikyuGokei) }
        if (elem.yoshaUnchin) { elem.yoshaUnchin = filter.numericFormatter(elem.yoshaUnchin) }
        if (elem.yoshaHiwayPrice) { elem.yoshaHiwayPrice = filter.numericFormatter(elem.yoshaHiwayPrice) }
        if (elem.yoshaUnchinHokaKingaku) { elem.yoshaUnchinHokaKingaku = filter.numericFormatter(elem.yoshaUnchinHokaKingaku) }
        if (elem.yoshaUnchinHokaHikazei) { elem.yoshaUnchinHokaHikazei = filter.numericFormatter(elem.yoshaUnchinHokaHikazei) }
        if (elem.shiharaiGokei) { elem.shiharaiGokei = filter.numericFormatter(elem.shiharaiGokei) }
        return elem
      })
    },
    isCsvButtonDisabled () {
      return this.rows.length === 0
    },
    ...mapGetters({
      viewTitle: 'system/viewTitle',
      usersEigyoshoCd: 'users/eigyoshoCd',
      eigyoshoList: 'DDMasters/mstEigyosho',
      torihikisakiList: 'DDMasters/mstTorihikisaki',
      hacchakuchiList: 'DDMasters/mstHacchakuchi',
      shubetsuList: 'DDMasters/mstShubetsu',
      helpUseFlg: 'users/helpUseFlg'
    }),
    // 営業所マスタフィルター --> ここから
    filteredEigyoshoList () {
      const target = filter.dateFormatter(new Date())
      return this.eigyoshoList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target && elem.eigyoshoKbn === '01'
      })
    },
    // 営業所マスタフィルター <-- ここまで
    // 取引先マスタフィルター --> ここから
    filteredMstTorihikisaki () {
      return this.torihikisakiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      })
    },
    filteredMstTokuisakiList () {
      const target = filter.dateFormatter(new Date())
      return this.filteredMstTorihikisaki.filter((t) => {
        return t.tekiyoStartYmdDisp <= target && t.tekiyoEndYmdDisp >= target && t.tokuisakiFlg === true
      })
    },
    filteredMstHacchusakiList () {
      const target = filter.dateFormatter(new Date())
      return this.filteredMstTorihikisaki.filter((t) => {
        return t.tekiyoStartYmdDisp <= target && t.tekiyoEndYmdDisp >= target && t.hacchusakiFlg === true
      })
    },
    // 取引先マスタフィルター <-- ここまで
    // 発着地マスタフィルター --> ここから
    filteredHacchakuchiList () {
      const target = filter.dateFormatter(new Date())
      return this.hacchakuchiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      })
    },
    // 発着地マスタフィルター <-- ここまで
    // 車種フィルター
    filteredSharyoShubetsList () {
      return this.sbtListFilterForDropDownItem(this.shubetsuList, 'GVI011')
    },
    isEditButtonDisabled () {
      if (this.modeKengen === 0) {
        return true
      }
      if (this.selected.length === 1) {
        return false
      }
      return true
    },
    isAddButtonDisplay () {
      if (this.modeKengen === 0) {
        return false
      }
      return true
    }
  },
  created () {
  },
  mounted () {
    this.initialize()
  },
  beforeRouteUpdate (to, from, next) {
    this.$refs.initialize()
    next()
  },
  methods: {
    getCloneTargetMethod: function () {
      return {
        rows: this.rows,
        conditions: this.conditions,
        searchText: this.searchText
      }
    },
    initialize: function () {
      const self = this
      const opt = {
        loadMasters: ['msttorihikisaki', 'msteigyosho', 'msthacchakuchi', 'mstshubetsu'],
        defineHeaderPromise: () => {
          return new Promise(resolve => {
            console.log('MstTeikeiList.defineHeaderPromise')
            self.headers = [
              { text: '編集', value: 'actions', sortable: false, width: '20px' },
              { text: 'コースNo', value: 'teikeiCourseNo' },
              { text: 'コース名称', value: 'teikeiCourseNm' },
              { text: '得意先', value: 'tokuisakiDisp' },
              { text: '担当営業所', value: 'tantoEigyoshoDisp' },
              { text: '注文番号', value: 'chumonNo' },
              { text: '商品', value: 'hinmeiDisp' },
              { text: '発地', value: 'hatsuchiDisp' },
              { text: '発時刻', value: 'hatsuchiHmsDisp' },
              { text: '経由地', value: 'keiyuchiId1Disp' },
              { text: '着地', value: 'chakuchiDisp' },
              { text: '着時刻', value: 'chakuchiHmsDisp' },
              { text: '請求車種', value: 'seikyuShashuSbtNm' },
              { text: '運賃計算方法', value: 'unchinKeisanKbnNm' },
              { text: '数量', value: 'juchuSuryo', align: 'end' },
              { text: '単位', value: 'unitKbnNm' },
              { text: '重量', value: 'juchuJuryo', align: 'end' },
              { text: '単価', value: 'tanka', align: 'end' },
              { text: '運賃', value: 'kihonUnchin', align: 'end' },
              { text: '運賃(高速)', value: 'hiwayPrice', align: 'end' },
              { text: 'その他課税', value: 'unchinHokaKingaku', align: 'end' },
              { text: 'その他非課税', value: 'unchinHokaHikazei', align: 'end' },
              { text: '時間割増金額', value: 'jikanWarimashiKingaku', align: 'end' },
              { text: '距離割増金額', value: 'kyoriWarimashiKingaku', align: 'end' },
              { text: '割増その他', value: 'warimashiSonotaKingaku', align: 'end' },
              { text: '請求金額合計', value: 'seikyuGokei', align: 'end' },
              { text: '請求用備考', value: 'seikyuBiko' },
              { text: '支払運賃', value: 'yoshaUnchin', align: 'end' },
              { text: '支払運賃(高速)', value: 'yoshaHiwayPrice', align: 'end' },
              { text: '支払その他課税', value: 'yoshaUnchinHokaKingaku', align: 'end' },
              { text: '支払その他非課税', value: 'yoshaUnchinHokaHikazei', align: 'end' },
              { text: '支払金額合計', value: 'shiharaiGokei', align: 'end' },
              { text: '支払用備考', value: 'shiharaiBiko' }
            ]
            resolve()
          })
        },
        initializeInputPromise: function () {
          self.initBindVariables()
        },
        savedInputRestorePromise: (c) => {
          // ユーザ保存項目の復元
          self.conditions = { ...self.conditions, ...c }
          return new Promise(resolve => {
            self.loadFromCache()
              .then((c) => {
                console.log('MstTeikeiList.savedInputRestorePromise', c)
                resolve()
              })
          })
        },
        researchPromise: (c) => {
          console.log('MstTeikeiList.researchPromise', c)
          return new Promise(resolve => {
            self.conditions = c.cache.value ? c.cache.value.conditions || {} : self.conditions
            self.onSearchButtonClick()
            resolve()
            // self.search().then(() => {
            //   resolve()
            // })
          })
        },
        restoreViewPromise: (c) => {
          console.log('MstTeikeiList.restoreViewPromise', c)
          return new Promise(resolve => {
            self.conditions = c.cache.value.conditions || {}
            self.searchText = c.cache.value.searchText || ''
            self.rows = c.cache.value.rows || []
          })
        },
        settingButtonStatePromise: (kengen) => {
          console.log('MstTeikeiList.settingButtonStatePromise', kengen)
          return new Promise(resolve => {
            console.log('settingButtonStatePromise', kengen)
            if (kengen.kengenKbn === '10') {
              // 読取モード
              self.modeKengen = 0
            } else if (kengen.kengenKbn === '20') {
              // 削除不可モード
              self.modeKengen = 1
            } else {
              // フルアクセス
              self.modeKengen = 2
            }

            this.$nextTick(() => {
              document.getElementById('heavy-element').style.display = ''
            })

            resolve()
          })
        }
      }
      this.initializeForViewer(opt)
    },
    onSearchButtonClick: function (e) {
      this.selected = []
      this.page = 1

      const self = this
      const opt = {
        searchRequestPromise: function () {
          return new Promise(resolve => {
            self.HttpClient.post('/api/v1/VwCD2mstd0460/search', self.conditions)
              .then((data) => {
                resolve(data)
              })
          })
        },
        searchResultMethod: function (data) {
          self.rows = data.payload

          const cache = {
            rows: self.rows,
            conditions: self.conditions,
            searchText: self.searchText
          }
          self.saveToChache(cache)
            .then(() => {
              return {
                seikyuShashuSbt: self.conditions.seikyuShashuSbt
              }
            })
        },
        getSavedInputMethod: function () {
          return {
            seikyuShashuSbt: self.conditions.seikyuShashuSbt ?? ''
          }
        }
      }
      this.search(opt)
    },
    clear: function () {
      console.log('NewButton pushed')
      const p = modals.showConfirm
      p('COMQ0006').then((ok) => {
        console.log('clearInputs')
        if (ok === false || ok === undefined) { return }
        this.initBindVariables()
      })
      this.Effects.loadComplete()
    },
    onClearButtonClick: function (e) {
      console.log('clear pushed')
      this.Effects.loadStart()
      this.clear()
    },
    onRowDoubleClick: function (e, f) {
      console.log(e, f)
      this.Effects.loadStart()
      this.transition(0, { id: f.item.id })
    },
    onCsvButtonClick: function (e) {
      this.HttpClient
        .post('/api/v1/VwCD2mstd0460/DownloadForLite', this.conditions)
        .then((data) => {
          const ts = date.getCurrentDate().replaceAll('/', '') + '_' + date.getCurrentTime().replaceAll(':', '')
          const bom = new Uint8Array([0xEF, 0xBB, 0xBF])
          const blob = new Blob([bom, data], { type: 'text/csv' })
          const elem = document.getElementById('download')
          elem.href = window.URL.createObjectURL(blob)
          elem.download = '定型コース一覧_' + ts + '.csv'
          elem.click()
        })
    },
    onEditButtonClick: function (e) {
      console.log(e)
      this.Effects.loadStart()
      this.transition(0, { id: this.selected[0].id })
    },
    onRowEditButtonClick: function (item) {
      // 画面遷移
      this.Effects.loadStart()
      this.transition(0, { id: item.id })
    },
    onCreateButtonClick: function (e) {
      console.log(e)
      this.Effects.loadStart()
      this.transition(0, { id: 0 })
    },
    searchValidate: function () {
      return true
    },
    // ----------------------------------------------------------------------------------------------------
    // 内部共通関数
    // ----------------------------------------------------------------------------------------------------
    initBindVariables: function () {
      this.conditions = {
        teikeiCourseNo: '',
        teikeiCourseNm: '',
        tokuisakiCd: '',
        chumonNo: '',
        ohfukuSbt: '',
        seikyuShashuSbt: '',
        tantoEigyoshoCd: this.usersEigyoshoCd,
        hatsuchiCd: '',
        chakuchiCd: ''
      }
      this.searchText = ''
      this.rows = []
      this.selected = []
      this.page = 1
    }
  }
}
